import script from "./SearchPageSearchResultsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageSearchResultsTable.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPageSearchResultsTable.vue?vue&type=style&index=0&id=2ae1a8da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ae1a8da"]])

export default __exports__